export default __webpack_public_path__ + "static/media/_ic_wallet_inspect.7a95adaa.svg";